'use client'
import type DefaultTheme from '@effektify/theme/default'

import defaultTheme from '@effektify/theme/default'
import {
  createTheme,
  ThemeOptions,
} from '@mui/material/styles'

const themeOptions = {
  ...defaultTheme,
  cssVariables: true,
} as const
const theme = createTheme(themeOptions as ThemeOptions)

type Theme = typeof theme

export default theme

export type {
  DefaultTheme as EffektifyVariables,
  Theme,
}
